// MUST stay the first import: this installs crypto.randomUUID on WebViews that lack
// it, and an ES module's imports are evaluated before any of this file's statements.
// Importing App first would run AuthProvider's module body — which constructs
// PublicClientApplication — before the shim existed, so moving or de-hoisting this
// silently restores the WIPE-1338 crash on old Android WebViews.
import './utils/randomUuidShim'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initCapacitor } from './capacitor'
import { initPostHog, captureError, runDiagCrashIfRequested, diagCorrelationId } from './services/posthog'
import { reloadOnStaleBuild } from './services/staleBuildReload'

initPostHog()
initCapacitor()
runDiagCrashIfRequested()
reloadOnStaleBuild()

// A correlationId on the URL marks a synthetic monitoring crash probe; forward
// it onto whatever the global handlers report so the validator can match the
// event. Real page loads omit it.
const correlationProps = () => {
  const id = diagCorrelationId()
  return id ? { monitor_correlation_id: id } : {}
}

// Global error handler for uncaught exceptions. This is the system-wide
// reporter — the diagnostic trigger only throws and relies on this.
window.addEventListener('error', (event) => {
  captureError(event.error, {
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    ...correlationProps(),
  });
});

// Promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  captureError(new Error(event.reason), {
    type: 'unhandled_promise_rejection',
    ...correlationProps(),
  });
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
